export enum DERIVED_KEY_PURPOSES {
  INVESTMENT = 'INVESTMENT',
  PROFILE = 'PROFILE',
  FUNDING_ROUND = 'FUNDING_ROUND',
  SOCIAL = 'SOCIAL',
  ADMIN = 'ADMIN',
  ESCROW = 'ESCROW',
  TRADING = 'TRADING',
}
